import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [cancellationStatus, setCancellationStatus] = useState(null); // null, 'processing', 'completed'
  const [cancellationMessage, setCancellationMessage] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  // Function to set processing status (called when cancellation starts)
  const setProcessingStatus = useCallback((message = 'Document Cancellation is Processing...') => {
    console.log('NotificationContext: Setting processing status:', message);
    console.log('NotificationContext: Current state before update:', { cancellationStatus, cancellationMessage, isVisible });
    setCancellationStatus('processing');
    setCancellationMessage(message);
    setIsVisible(true);
    console.log('NotificationContext: State updated to processing');
  }, [cancellationStatus, cancellationMessage, isVisible]);

  // Function to set completion status (called from notification hook)
  const setCompletionStatus = useCallback((message, status = 'completed') => {
    console.log('NotificationContext: Setting completion status:', message, status);
    setCancellationStatus(status);
    setCancellationMessage(message);
    setIsVisible(true);
  }, []);

  // Function to clear status (called when user clicks to dismiss)
  const clearStatus = useCallback(() => {
    console.log('NotificationContext: Clearing status');
    setCancellationStatus(null);
    setCancellationMessage('');
    setIsVisible(false);
  }, []);

  const value = {
    cancellationStatus,
    cancellationMessage,
    isVisible,
    setProcessingStatus,
    setCompletionStatus,
    clearStatus,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};
